import {
  faBank,
  faBell,
  faChevronDown,
  faCreditCard,
  faFileInvoiceDollar,
  faGift,
  faHouse,
  faLeftRight,
  faMoneyBill,
  faMoneyBillTransfer,
  faPeopleArrows,
  faPlus,
  faQrcode,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AuthContext from "context/AuthContext";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import ProfileMenu from "./ProfileMenu";

export default function Sidebar() {
  const { t } = useTranslation();
  const location = useLocation();

  //const [showWallets, setShowWallets] = useState(false);
  const [showProfileBottomSheet, setShowProfileBottomSheet] = useState(false);

  const { user, lastActivity, logoutUser, setLastActivity, hasNewNotification } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const activityListener = () => {
      setLastActivity(new Date());
    };
    window.addEventListener("mousemove", activityListener);

    return () => {
      window.removeEventListener("mousemove", activityListener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const inactivityTimeout = setTimeout(() => {
      const currentTime = new Date();
      const inactivityDuration = currentTime - lastActivity;
      if (inactivityDuration >= 360000) {
        logoutUser();
      }
    }, 60000);
    return () => {
      clearTimeout(inactivityTimeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastActivity]);

  //const APKUrl = "https://play.google.com/store/apps/details?id=com.app.alpay";
  //const IOSUrl = "https://apps.apple.com/al/app/alpay/id1624445869";

  useEffect(() => {
    //setUserPFP(user?.profile_pic);
    //setShowWallets(!location.pathname.includes("dashboard"));
  }, [location, user?.profile_pic]);

  const menu = [
    {
      title: t("NAV_HOME"),
      icon: faHouse,
      action: () => {
        navigate("/dashboard");
      },
      checkActive: () => {
        return location.pathname.includes("dashboard");
      },
      children: null,
    },
    {
      title: t("O_ADD_MONEY"),
      icon: faPlus,
      checkActive: () => {},
      children: [
        {
          title: t("MY_CARDS"),
          icon: faCreditCard,
          action: () => {
            navigate("/add-money/my-cards");
          },
          checkActive: () => {
            return location.pathname.includes("add-money/my-cards");
          }
        },
      ],
    },
    {
      title: t("DASHBOARD_TRANSFER_MONEY"),
      icon: faLeftRight,
      checkActive: () => {},
      children: [
        {
          title: t("TRANSFER_BETWEEN_ACCOUNTS"),
          icon: faMoneyBillTransfer,
          action: () => {
            navigate("/transfer-wallets");
          },
          checkActive: () => {
            return location.pathname.includes("transfer-wallets");
          },
        },
        {
          title: t("TRANSFER_USERNAME"),
          icon: faUser,
          action: () => {
            navigate("/transfer-username");
          },
          checkActive: () => {
            return location.pathname.includes("transfer-username");
          },
        },
        {
          title: t("NAV_GIFT_CARD"),
          icon: faGift,
          action: () => {
            navigate("/gift-cards");
          },
          checkActive: () => {
            return location.pathname.includes("gift-cards");
          },
        },
        {
          title: t("TRANSFER_QR_CODE"),
          icon: faQrcode,
          action: () => {
            //navigate("/transfer-qr-code");
          },
          checkActive: () => {
            return location.pathname.includes("transfer qr-code");
          },
        },
        {
          title: t("TRANSFER_WITHDRAW_BANK"),
          icon: faBank,
          action: () => {
            //navigate("/transfer-withdraw-bank")
          },
          checkActive: () => {
            return location.pathname.includes("withdraw-bank");
          },
        },
        {
          title: t("TRANSFER_WITHDRAW_CASH"),
          icon: faMoneyBill,
          action: () => {
            //navigate("/transfer-withdraw-cash");
          },
          checkActive: () => {
            return location.pathname.includes("withdraw-cash");
          },
        },
      ],
    },
    {
      title: t("NAV_PAYMENTS"),
      icon: faFileInvoiceDollar,
      checkActive: () => {},
      children: [
        {
          title: t("EALBANIA_PAYMENTS"),
          icon: `images/E-Albania.svg`,
          imgIcon: true,
          action: () => {
            navigate("/payments/ealbania");
          },
          checkActive: () => {
            return location.pathname.includes("payments/ealbania");
          },
        },
        {
          title: t("SMARTFIN_PAYMENTS"),
          icon: `images/smartfin.png`,
          imgIcon: true,
          action: () => {
            navigate("/payments/smartfin");
          },
          checkActive: () => {
            return location.pathname.includes("payments/smartfin");
          },
        },
        {
          title: t("LOAN"),
          icon: faBank,
          action: () => {
            //navigate("/payments/loans");
          },
          checkActive: () => {
            return location.pathname.includes("payments/loans");
          },
        },
        {
          title: t("SPLIT_BILL_PAYMENTS"),
          icon: faPeopleArrows,
          action: () => {
            //navigate("/payments/split-bill");
          },
          checkActive: () => {
            return location.pathname.includes("payments/split-bill");
          },
        },
      ],
    },
  ];

  if (!user) {
    return <></>;
  }

  return (
    <div
      className="
        hidden md:flex
        w-72 h-screen
        flex-col
        border-r border-gray-200 dark:border-gray-700
      "
    >
      <div className="flex flex-col p-4 w-full justify-center">
        <img className="h-[3rem] cursor-pointer hidden dark:block" src="images/whitelogo.svg" alt="LOGO" onClick={() => navigate("/dashboard")} />
        <img className="h-[3rem] cursor-pointer block dark:hidden" src="images/logo.svg" alt="LOGO" onClick={() => navigate("/dashboard")} />

        <nav className="space-y-1 mt-5">
          {menu.map((item, index) => (
            <SidebarItem key={index} item={item} />
          ))}
        </nav>
      </div>

      <div className="mt-auto">
        {/* {showWallets && (
          <div className="my-2 mx-2">
            <ScrollableWalletsDesktop sideBar={true} />
          </div>
        )} */}

        {/* <h2 className="download-title-centered">{t('SIDEBAR_DOWNLOAD_APP')}</h2>
        <div className="flex justify-between w-full gap-2 px-2">
          <a href="https://apps.apple.com/al/app/alpay/id1624445869" target="_blank" rel="noopener noreferrer">
            <img src="images/appstore.png" alt="Download on App Store" className="download-badge h-[3rem]"  />
          </a>

          <a href="https://play.google.com/store/apps/details?id=com.app.alpay" target="_blank" rel="noopener noreferrer">
            <img src="images/googleplay.png" alt="Get it on Google Play" className="download-badge h-[3rem]"  />
          </a>
        </div> */}

        <div className="border-t dark:border-gray-700 py-2">
          <div className="flex justify-between items-center mx-3">
            <div
              className="flex gap-2 items-center justify-start cursor-pointer w-full p-2 rounded-lg me-2"
              onClick={() => {
                setShowProfileBottomSheet(true);
              }}
            >
              <img className="w-10 h-10 rounded-full cursor-pointer object-cover" onClick={() => {}} src={user.profile_pic} alt="" />
              <div className="font-medium">
                <p className="m-0 leading-tight">
                  {user.first_name} {user.last_name}
                </p>
                <span className="text-xs leading-tight">@{user.username}</span>
              </div>
            </div>
            <div className="me-2 flex gap-2 items-center">
              <div className="relative">
                <FontAwesomeIcon icon={faBell} size="xl" className="cursor-pointer" onClick={() => navigate("/notifications")} />
                {hasNewNotification && <div className="w-2 h-2 bg-red-500 rounded-full absolute top-[0.1rem] right-[0.2rem]"></div>}
              </div>
            </div>
          </div>
        </div>

        {showProfileBottomSheet && (
          <div className="fixed inset-0 z-50 flex items-end justify-start">
            {/* Backdrop */}
            <div
              className={`absolute inset-0 bg-black/40 transition-opacity duration-200
                      opacity-100
                    `}
              onClick={() => {
                setShowProfileBottomSheet(false);
              }}
            />

            {/* Bottom Sheet */}
            <div
              className={`
                      bg-backdrop w-72 max-h-[80vh] rounded-t-2xl shadow-lg
                      "translate-y-full"
                    `}
            >
              {/* Content */}
              <div className="overflow-y-auto no-scrollbar max-h-[70vh] p-2 pt-4">
                <ProfileMenu
                  onClose={() => {
                    setShowProfileBottomSheet(false);
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function SidebarItem({ item }) {
  const [open, setOpen] = useState(true);

  const hasChildren = item.children && item.children.length > 0;

  return (
    <div>
      {/* Parent Item */}
      <button
        onClick={() => {
          if (hasChildren) {
            setOpen(!open);
          } else {
            item.action();
          }
        }}
        className={`sidebar_item ${item.checkActive() ? "sidebar_active" : ""}
          w-full flex justify-between items-center 
          px-3 py-2 rounded-lg`}
      >
        <span className="flex items-center gap-2">
          {item.imgIcon ? <img src={item.icon} className="w-[1.2rem] h-[1.2rem]" alt="" /> : <FontAwesomeIcon icon={item.icon} />}
          <span className="font-medium">{item.title}</span>
        </span>

        {hasChildren && <FontAwesomeIcon icon={faChevronDown} />}
      </button>

      {/* Children */}
      {hasChildren && open && (
        <div className="ml-6 mt-1 space-y-1">
          {item.children.map((child, i) => (
            <button
              key={i}
              className={`sidebar_item ${child.checkActive() ? "sidebar_active" : ""}
          w-full flex justify-between items-center 
          px-3 py-2 rounded-lg`}
              onClick={child.action}
            >
              <span className="flex items-center gap-2">
                {child.imgIcon ? <img src={child.icon} className="w-[1.2rem] h-[1.2rem]" alt="" /> : <FontAwesomeIcon icon={child.icon} />}
                <span className="font-medium">{child.title}</span>
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
